<template>
  <div :class="skinType == 2 ? 'bg_gray' : 'bg_white'">
    <!-- bg_white bg_gray  -->
    <article class="content" id="container">
      <nav class="navTabs">
        <ul>
          <li
            :class="item === showTit ? 'active' : ''"
            v-for="item in titList"
            :key="item"
            @click="checkTit(item)"
          >
            {{ item }}
          </li>
        </ul>
      </nav>
      <!-- 必读 -->
      <Read v-if="queryShow" :showTit="showTit" :token="weiToken"></Read>
      <!-- 大事提醒 -->
      <DsMore v-if="queryShow" :showTit="showTit" :token="weiToken"></DsMore>
      <!-- 财务透视 -->
      <Financial v-if="queryShow" :showTit="showTit" :token="weiToken"></Financial>
      <!-- 公司概况 -->
      <div ref="briefDom" v-if="queryShow">
        <Brief :showTit="showTit" :token="weiToken"></Brief>
      </div>
      <!-- 股本股东 -->
      <Shareholder v-if="queryShow" :showTit="showTit" :token="weiToken"></Shareholder>
      <!-- 分红融资 -->
      <Didend v-if="queryShow" :showTit="showTit" :token="weiToken"></Didend>
    </article>
  </div>
</template>

<script>
import { getToken } from "../api/index";
import mixins from "../mixins/index";
import Read from "../components/read";
import DsMore from "../components/ds_more";
import Financial from "../components/financial";
import Brief from "../components/brief.vue";
import Shareholder from "../components/shareholder.vue";
import Didend from "../components/didend";
export default {
  name: "Home",
  data() {
    return {
      titList: ["操盘必读", "大事提醒", "财务透视", "公司概况", "股本股东", "分红融资"],
      showTit: "操盘必读",
      skinType: 2,
      weiToken: "",
      queryShow: false,
    };
  },
  components: { Read, DsMore, Financial, Brief, Shareholder, Didend },
  mixins: [mixins],
  watch: {
    showTit: {
      handler() {
        this.goScrollTop();
      },
    },
  },
  created() {
    document.title = decodeURI(this.getUrlQuery("name")) + "F10";
    if (this.getUrlQuery("themeStyleVs") == 2) {
      document.querySelector("body").setAttribute("style", "background-color:#0c0f13;");
    } else {
      document.querySelector("body").setAttribute("style", "background-color:#FFF;");
    }
    this.skinType = this.getUrlQuery("themeStyleVs");
    this.getWeiToken();
  },
  mounted() {},
  methods: {
    checkTit: function (id) {
      this.showTit = id;
    },
    // 获取token
    getWeiToken: function () {
      let that = this;
      let obj = {
        merId: window.config.merId,
        busiCode: window.config.busiCode,
        sign: window.config.sign,
      };
      getToken(JSON.stringify(obj))
        .then((res) => {
          that.queryShow = true;
          if (res.resCode === "000000") {
            that.weiToken = res.resData.token;
          }
        })
        .catch((err) => {
          console.log(err);
          that.queryShow = true;
        });
    },
  },
};
</script>
<style lang="less">
@import "../assets/css/style2.less";
</style>
<style lang="less" scoped></style>
